import createAdapter from './createAdapter'
import { getItem, setItem, removeItem } from '../../storeManager'
import { excludeVAT } from '../../utils'
import { isSSR } from 'js/isSSR'

function getAtGdCookie(): string | null {
  if (isSSR) return null
  const match = document.cookie.match(/(?:^|;\s*)at_gd=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : null
}

export const adtraction = createAdapter(() => true, {
  trackPurchase(
    transactionId: string | number,
    coupon: string | null,
    orderValue: number,
    currency: string,
  ) {
    if (currency !== 'SEK') return

    const atGd = getAtGdCookie() || getItem('adtractionAtGd')
    if (!atGd) return

    if (!getItem('state')) {
      return
    }

    const { user: userState, locale: localeState } = JSON.parse(
      getItem('state') as string,
    )
    const country = userState.profile.country || localeState.country
    const amount = parseFloat(excludeVAT(orderValue, country)).toFixed(2)

    const params = new URLSearchParams({
      t: '3',
      tk: '1',
      am: amount,
      c: currency,
      ti: String(transactionId),
      tp: '1951492787',
      cpn: coupon || '',
      trt: '4',
      ss: '1',
      ap: '1951492778',
      at_gd: atGd,
    })

    const pixel = new Image(0, 0)
    pixel.src = `https://ion.lifesum.com/t/t?${params.toString()}`
    document.getElementsByTagName('body')[0].appendChild(pixel)
    removeItem('adtractionAtGd')
  },
  saveId() {
    const atGd = new URLSearchParams(document.location.search).get('at_gd')
    if (atGd) {
      setItem('adtractionAtGd', atGd)
    }
  },
})
